import { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import scholarship1 from '../assets/banner1.png';
import scholarship2 from '../assets/banner2.png';
import scholarship3 from '../assets/banner3.png';
import scholarship4 from '../assets/banner4.png';
import scholarship5 from '../assets/banner6.png';
import scholarship6 from '../assets/banner9.png';
import scholarship7 from '../assets/banner10.png';
import scholarship8 from '../assets/banner11.png';
import scholarship10 from '../assets/banner13.png';
import scholarship9 from '../assets/banner12.png';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AutoPopUp from './AutoPopUp';

const OffersHome = () => {
    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    return (
        <Box sx={{ bgcolor: '#f8f9fa', py: 8, mt: 0 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {[scholarship1, scholarship2, scholarship4, scholarship5, scholarship6, scholarship7,scholarship8, scholarship9, scholarship10].map((item, index) => (
                        <Grid item xs={12} md={4}>
                            <Box
                                component="img"
                                src={item}
                                alt="Aakash Yelahanka"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 3,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default OffersHome;